import type { Node as ProsemirrorNode } from "prosemirror-model";

import React from "react";

import { IntegrationObjectToken } from "@agent-ui/features/chat/components/chat-elements/chat-tokens/IntegrationObjectToken";
import { createRoot } from "react-dom/client";

export function IntegrationObjectTokenNode({
  node,
}: {
  node: ProsemirrorNode;
}) {
  const dom = document.createElement("span");
  dom.className = "integration-object-component";
  dom.contentEditable = "false";
  dom.style.display = "inline";

  const data = node.attrs.data;
  if (data?.object?.title || data?.object?.id) {
    const root = createRoot(dom);
    root.render(React.createElement(IntegrationObjectToken, { data }));

    return {
      dom,
      destroy: () => {
        root.unmount();
      },
    };
  }

  return { dom };
}
